import { render, staticRenderFns } from "./common-project-step-header.vue?vue&type=template&id=3c7c4b1c"
import script from "./common-project-step-header.vue?vue&type=script&lang=js"
export * from "./common-project-step-header.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports